module.exports = __webpack_public_path__ + "static/media/kit_robotArm_bg.3c21257f.png";